import type { Avatar as AvatarData } from "@coup/shared";
import { COLOR_HEX, EMBLEM_PATH, FRAME_HEX } from "../art";
import { Icon } from "./Icon";
import styles from "./Avatar.module.css";

interface Props {
  avatar: AvatarData;
  size: number;
  /** Frame ring width. */
  ring?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function Avatar({
  avatar,
  size,
  ring = Math.max(1.5, Math.round(size / 13)),
  className,
  style,
}: Props) {
  const preset = avatar.kind === "preset";
  return (
    <div
      className={`${styles.avatar} ${className ?? ""}`}
      style={{
        width: size,
        height: size,
        borderWidth: ring,
        borderColor: FRAME_HEX[avatar.frame],
        background: preset ? COLOR_HEX[avatar.color] : undefined,
        ...style,
      }}
    >
      {preset ? (
        <Icon
          path={EMBLEM_PATH[avatar.emblem]}
          size={Math.round(size * 0.5)}
          color="#17130f"
          width={size > 60 ? 1.6 : 1.8}
        />
      ) : (
        <img src={avatar.dataUrl} alt="" />
      )}
    </div>
  );
}
